import React from "react";
import { IComment } from "../../../../api/comments";
import Comment from "../Comment";

export interface CommentsListProps {
  comments: IComment[];
  containerRef?: React.Ref<HTMLDivElement>;
  now?: Date;
  disableScroll?: boolean;
}

export const CommentsList: React.FC<CommentsListProps> = ({
  comments,
  containerRef,
  now,
  disableScroll = false,
}) => {
  const renderItems = () => {
    return (
      <div className="flex flex-col gap-6">
        {comments.map((c) => (
          <Comment key={c.comment_id} comment={c} now={now} />
        ))}
      </div>
    );
  };

  return (
    <div
      ref={containerRef}
      className={disableScroll ? "px-4 pb-4" : "overflow-y-auto h-full px-4 pb-4"}
    >
      {renderItems()}
    </div>
  );
};

export default CommentsList;
